import http from '@yld/yun-utils-http'
import { BASE_URL } from '@yld/yun-utils-host'

const customerApi = BASE_URL.WG + '/api/40004'
const orderApi = BASE_URL.WG + '/api/30004'
const financeApi = BASE_URL.WG + '/api/40008'
const certificationApi = BASE_URL.WG + '/api/10030'
const api_10067 = BASE_URL.WG + '/api/10067'

export function getInfo(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/getById', data)
}

// 获取用户所有菜单数据
export function getMenuList(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/menu/getMenuByUserId',data)
}

// 获取admin菜单
export function getAdminMenuList(){
  return http.post(BASE_URL.WG + '/api/10067/menu/get_inside_menu_function_list')
}

// 退出登录
export function logout() {
  return http.post(BASE_URL.WG + '/api/10020/sso/logout')
}

// 获取用户信息
export function getLoginUser() {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/getLoginUser')
}

// 获取主公司logo
export function getMainBranchLogo(){
  return http.post(BASE_URL.WG + '/api/40002/rms/branch/Sigil/get_main_branch_logo')
}

// 获取CRM客户有权限的button key列表
export function getAuthorityButtonKeys(data) {
  return http.post(customerApi + '/authority/getCustomerAuthority', data)
}

// 获取订单详情button key和详情权限
export function getOrderByButtonKeys(data){
  return http.post(orderApi + '/orderAuthority/getOrderAuthority', data)
}

// 获取财务button key列表
export function getFinanceByButtonKeys(data){
  return http.post(financeApi + '/financeAuth/btnPermission', data)
}
// 天眼查公司信息
export function companyBasicCoreSimple(data){
  return http.post(certificationApi + '/companyBasicCore/searchCompanyBasicCoreSimple', data)
}

// 查询版本到期时间
export function getTenantSummary() {
  return http.post(api_10067 + '/tenant/getTenantSummary')
}

// 获取皮肤
export function getSkinJson(data){
  return http.post(api_10067 + '/common/skin/get_skin_json',data)
}

// 获取dayu用户主题色
export function getUserColor() {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/getUserSubjectColor')
}
